(() => {
  const BTN_SEL = ".header__icon--favorites";
  const BADGE_SEL = "[data-fav-count]";
  const KEY = "hb_favorites_v1";

  function updateHeaderFavBadge() {
    const btn = document.querySelector(BTN_SEL);
    if (!btn) return;
    
    // On cible le badge UNIQUEMENT dans le bouton favoris du header
    const badge = btn.querySelector(BADGE_SEL);
    if (!badge) return;

    let count = 0;
    try {
      const data = JSON.parse(localStorage.getItem(KEY));
      count = Array.isArray(data) ? data.length : (data ? Object.keys(data).length : 0);
    } catch(e) { count = 0; }

    // On ne touche au badge que s'il est dans le header
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = "flex";
      badge.removeAttribute("hidden");
    } else {
      badge.style.display = "none";
      badge.setAttribute("hidden", "");
    }
    btn.classList.toggle("is-active", count > 0);
  }

  // Écouteurs d'événements
  document.addEventListener("DOMContentLoaded", updateHeaderFavBadge);
  window.addEventListener("hb:favorites:changed", updateHeaderFavBadge);
  window.addEventListener("storage", updateHeaderFavBadge);
  document.addEventListener("shopify:section:load", updateHeaderFavBadge);
  
  // Mise à jour lors du clic sur un bouton favoris
  document.addEventListener("click", (e) => {
    if (e.target.closest(".hb-fav, .favorite-btn, [data-favorite-btn], [data-habitoi-fav]")) {
      setTimeout(updateHeaderFavBadge, 150);
    }
  });

  window.habitoiUpdateFavBadge = updateHeaderFavBadge;
})();